module.exports = __webpack_public_path__ + "img/call-center.6f61f2da.png";